import { defineComponent as _defineComponent } from 'vue'
import { PropType, computed } from "vue";
import TextInput from "@/components/shared/inputs/TextInput.vue";
import CustomSelect from "@/components/shared/selects/CustomSelect.vue";
import { IFilter, IOption } from "@/domain/entities/filter/filter.types";
import BaseTextarea from "../shared/inputs/base/BaseTextarea.vue";


const __default__ = {
  name: "DynamicFormField",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  filter: {
    type: Object as PropType<IFilter>,
    required: true,
  },
  placeholder: {
    type: String,
    default: "선택",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  value: {
    type: null as any,
  },
  rules: {
    type: Object,
  },
},
  emits: ["onUpdateValue", "onSelectOption"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const inputValue = computed({
  get(): any {
    return props.value;
  },
  set(inputValue: any) {
    if (props.value === inputValue) return;
    emitOnUpdateValue(inputValue);
  },
});

const getComponent = (filter: IFilter) => {
  return componentMap[filter.fieldType ?? ""];
};

const componentMap: Record<string, any> = {
  string: TextInput,
  text: BaseTextarea,
  option: CustomSelect,
};

const emitOnSelectOption = (filter: IFilter, option: IOption) => {
  emit("onSelectOption", filter, option);
};

const emitOnUpdateValue = (value?: any) => {
  if (value === undefined) return;
  emit("onUpdateValue", props.filter, value);
};

const __returned__ = { props, emit, inputValue, getComponent, componentMap, emitOnSelectOption, emitOnUpdateValue }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})